import React from 'react'
import MenuItem from './MenuItem'

import styles from './Menu.module.css'

const Menu = ({ children }) => {
  return <div className={styles.menu}>{children}</div>
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/header/menu/Menu.js